
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class OpeningStockLaborGrid extends Serenity.EntityGrid<OpeningStockLaborRow, any> {
        protected getColumnsKey() { return 'Inventory.OpeningStockLabor'; }
        protected getDialogType() { return OpeningStockLaborDialog; }
        protected getIdProperty() { return OpeningStockLaborRow.idProperty; }
        protected getInsertPermission() { return OpeningStockLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return OpeningStockLaborRow.localTextPrefix; }
        protected getService() { return OpeningStockLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}